<app-office-nav *ngIf="!noNav"></app-office-nav>
<router-outlet></router-outlet>